import { Injectable } from "@angular/core";

@Injectable()
export class SharedService {

  isAnonymous:boolean = false;
  isAnonymousAll:boolean = false;

}
